import Vue from 'vue';
import Router from 'vue-router';
import auth from '@/helpers/auth';

Vue.use(Router);

const isAuth = (to, from, next) => {
	if (!auth.loggedIn()) {
		next({
			name: 'login',
			query: { redirect: to.fullPath },
		});
	} else {
		next();
	}
};

const isUnauth = (to, from, next) => {
	if (auth.loggedIn()) {
		if (from.name == null) {
			next({ name: 'dashboard' });
		} else {
			next({ name: from.name });
		}
	} else {
		next();
	}
};

export default new Router({
	mode: 'history',
	// mode: 'hash',
	duplicateNavigationPolicy: 'ignore',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/login',
			name: 'login',
			beforeEnter: isUnauth,
			component: () => import('@/views/vo-general/autentikasi/Login.vue'),
		},
		{
			path: '/sso/:token',
			name: 'sso',
			component: () => import('@/views/vo-general/autentikasi/LoginSSO.vue'),
		},
		{
			path: '/',
			beforeEnter: isAuth,
			component: () => import('@/components/layout/vo-general/Main.vue'),
			children: [
				{
					path: '/',
					name: 'dashboard',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/dashboard/Dashboard.vue')
				},
				{
					path: '/profil',
					name: 'profil',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/profil/profil/Profil.vue')
				},
				{
					path: '/ubah-password',
					name: 'ubah-password',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/profil/ubahPassword/UbahPassword.vue')
				},
				{
					path: '/registrasi-premium',
					name: 'registrasi-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_premium/registrasi/Registrasi.vue')
				},
				{
					path: '/kloning-mitra-premium/',
					name: 'kloning-mitra-premium',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/jaringan_premium/registrasi/CloningMitra.vue')
				},
				{
					path: '/genealogy-premium',
					name: 'genealogy-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_premium/genealogy/Genealogy.vue')
				},
				{
					path: '/sponsor-pribadi-premium',
					name: 'sponsor-pribadi-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_premium/sponsorPribadi/SponsorPribadi.vue')
				},
				{
					path: '/pertumbuhan-jaringan-premium',
					name: 'pertumbuhan-jaringan-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_premium/pertumbuhanJaringan/PertumbuhanJaringan.vue')
				},
				{
					path: '/downline-premium',
					name: 'downline-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_premium/downline/Downline.vue')
				},
				{
					path: '/upgrade',
					name: 'upgrade',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_premium/upgrade/Upgrade.vue')
				},

				// jaringan ekonomi
				{
					path: '/registrasi-ekonomis',
					name: 'registrasi-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ekonomi/registrasi/Registrasi.vue')
				},
				{
					path: '/kloning-mitra-ekonomis/',
					name: 'kloning-mitra-ekonomis',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/jaringan_ekonomi/registrasi/CloningMitra.vue')
				},
				{
					path: '/genealogy-ekonomis',
					name: 'genealogy-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ekonomi/genealogy/Genealogy.vue')
				},
				{
					path: '/genealogy-ekonomis-ro',
					name: 'genealogy-ekonomis-ro',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ekonomi/genealogy_ro/Genealogy.vue')
				},
				{
					path: '/sponsor-pribadi-ekonomis',
					name: 'sponsor-pribadi-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ekonomi/sponsorPribadi/SponsorPribadi.vue')
				},
				{
					path: '/pertumbuhan-jaringan-ekonomis',
					name: 'pertumbuhan-jaringan-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ekonomi/pertumbuhanJaringan/PertumbuhanJaringan.vue')
				},
				{
					path: '/downline-ekonomis',
					name: 'downline-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ekonomi/downline/Downline.vue')
				},
				// end jaringan ekonomi

				// jaringan ceria
				{
					path: '/registrasi-ceria',
					name: 'registrasi-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ceria/registrasi/Registrasi.vue')
				},
				{
					path: '/kloning-mitra-ceria/',
					name: 'kloning-mitra-ceria',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/jaringan_ceria/registrasi/CloningMitra.vue')
				},
				{
					path: '/genealogy-ceria',
					name: 'genealogy-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ceria/genealogy/Genealogy.vue')
				},
				{
					path: '/sponsor-pribadi-ceria',
					name: 'sponsor-pribadi-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ceria/sponsorPribadi/SponsorPribadi.vue')
				},
				{
					path: '/pertumbuhan-jaringan-ceria',
					name: 'pertumbuhan-jaringan-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ceria/pertumbuhanJaringan/PertumbuhanJaringan.vue')
				},
				{
					path: '/downline-ceria',
					name: 'downline-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_ceria/downline/Downline.vue')
				},
				// end jaringan ceria

				// jaringan supreme
				{
					path: '/registrasi-supreme',
					name: 'registrasi-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_supreme/registrasi/Registrasi.vue')
				},
				{
					path: '/kloning-mitra-supreme/',
					name: 'kloning-mitra-supreme',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/jaringan_supreme/registrasi/CloningMitra.vue')
				},
				{
					path: '/genealogy-supreme',
					name: 'genealogy-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_supreme/genealogy/Genealogy.vue')
				},
				{
					path: '/sponsor-pribadi-supreme',
					name: 'sponsor-pribadi-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_supreme/sponsorPribadi/SponsorPribadi.vue')
				},
				{
					path: '/pertumbuhan-jaringan-supreme',
					name: 'pertumbuhan-jaringan-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_supreme/pertumbuhanJaringan/PertumbuhanJaringan.vue')
				},
				{
					path: '/downline-supreme',
					name: 'downline-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/jaringan_supreme/downline/Downline.vue')
				},
				// end jaringan supreme

				{
					path: '/beli-produk',
					name: 'beli-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/transaksiProduk/beliProduk/BeliProduk.vue')
				},
				{
					path: '/lap-pembelian-produk',
					name: 'lap-pembelian-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/transaksiProduk/lapPembelianProduk/LapPembelianProduk.vue')
				},
				{
					path: '/detail-pembelian-produk/:code?',
					name: 'detail-pembelian-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/transaksiProduk/lapPembelianProduk/DetailPembelianProduk.vue')
				},
				{
					path: '/input-ro',
					name: 'input-ro',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/repeatOrder/inputRO/InputRO.vue')
				},
				{
					path: '/riwayat-ro',
					name: 'riwayat-ro',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/repeatOrder/riwayatRO/RiwayatRO.vue')
				},
				{
					path: '/stok-serial',
					name: 'stok-serial',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/serial/stokSerial/StokSerial.vue')
				},
				{
					path: '/kirim-serial',
					name: 'kirim-serial',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/serial/kirimSerial/KirimSerial.vue')
				},
				{
					path: '/riwayat-kirim-serial',
					name: 'riwayat-kirim-serial',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/serial/riwayatKirimSerial/RiwayatKirimSerial.vue')
				},
				{
					path: '/riwayat-transaksi-serial',
					name: 'riwayat-transaksi-serial',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/serial/riwayatTransaksiSerial/RiwayatTransaksiSerial.vue')
				},
				{
					path: '/data-stokis',
					name: 'data-stokis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/dataStokis/DataStokis.vue')
				},

				// komisi premium
				{
					path: '/summary-komisi-premium',
					name: 'summary-komisi-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_premium/summaryKomisi/SummaryKomisi.vue')
				},
				{
					path: '/riwayat-komisi-premium',
					name: 'riwayat-komisi-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_premium/riwayatKomisi/RiwayatKomisi.vue')
				},
				{
					path: '/riwayat-transfer-premium',
					name: 'riwayat-transfer_premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_premium/historiTransfer/HistoriTransfer.vue')
				},
				// komisi premium

				// komisi ekonomi
				{
					path: '/summary-komisi-ekonomis',
					name: 'summary-komisi-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ekonomi/summaryKomisi/SummaryKomisi.vue')
				},
				{
					path: '/riwayat-komisi-ekonomis',
					name: 'riwayat-komisi-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ekonomi/riwayatKomisi/RiwayatKomisi.vue')
				},
				{
					path: '/riwayat-transfer-ekonomis',
					name: 'riwayat-transfer_ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ekonomi/historiTransfer/HistoriTransfer.vue')
				},

				{
					path: '/statement-komisi-ekonomis/',
					name: 'statement-komisi-ekonomis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ekonomi/historiTransfer/StatementKomisi.vue')
				},
				// komisi ekonomi

				// komisi ceria
				{
					path: '/summary-komisi-ceria',
					name: 'summary-komisi-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ceria/summaryKomisi/SummaryKomisi.vue')
				},
				{
					path: '/riwayat-komisi-ceria',
					name: 'riwayat-komisi-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ceria/riwayatKomisi/RiwayatKomisi.vue')
				},
				{
					path: '/riwayat-transfer-ceria',
					name: 'riwayat-transfer_ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ceria/historiTransfer/HistoriTransfer.vue')
				},

				{
					path: '/statement-komisi-ceria/',
					name: 'statement-komisi-ceria',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_ceria/historiTransfer/StatementKomisi.vue')
				},
				// komisi ceria

				// komisi supreme
				{
					path: '/summary-komisi-supreme',
					name: 'summary-komisi-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_supreme/summaryKomisi/SummaryKomisi.vue')
				},
				{
					path: '/riwayat-komisi-supreme',
					name: 'riwayat-komisi-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_supreme/riwayatKomisi/RiwayatKomisi.vue')
				},
				{
					path: '/riwayat-transfer-supreme',
					name: 'riwayat-transfer_supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_supreme/historiTransfer/HistoriTransfer.vue')
				},

				{
					path: '/statement-komisi-supreme/',
					name: 'statement-komisi-supreme',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_supreme/historiTransfer/StatementKomisi.vue')
				},
				// komisi supreme

				{
					path: '/statement-komisi-premium/',
					name: 'statement-komisi-premium',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi_premium/historiTransfer/StatementKomisi.vue')
				},
				{
					path: '/peringkat-saya',
					name: 'peringkat-saya',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/peringkat/peringkatSaya/PeringkatSaya.vue')
				},
				{
					path: '/list-reward',
					name: 'list-reward',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/reward/listReward/ListReward.vue')
				},
				{
					path: '/reward-saya',
					name: 'histori-reward',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/reward/rewardSaya/RewardSaya.vue')
				},

				{
					path: '/list-reward-flush-out',
					name: 'list-reward-flush-out',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/reward_flushout/listReward/ListReward.vue')
				},
				// {
				// 	path: '/reward-flush-out-saya',
				// 	name: 'histori-reward-flush-out',
				// 	beforeEnter: isAuth,
				// 	component: () => import('@/views/vo-general/reward_flushout/rewardSaya/RewardSaya.vue')
				// },

				{
					path: '/list-reward-planb',
					name: 'list-reward-planb',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/reward_planb/listReward/ListReward.vue')
				},
				// {
				// 	path: '/reward-planb-saya',
				// 	name: 'histori-reward-planb',
				// 	beforeEnter: isAuth,
				// 	component: () => import('@/views/vo-general/reward_planb/rewardSaya/RewardSaya.vue')
				// },

				{
					path: '/testimoni',
					name: 'testimoni',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/testimoni/Testimoni.vue')
				},
				{
					path: '/pengumuman',
					name: 'pengumuman',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pengumuman/Pengumuman.vue')
				},
				{
					path: '/detail-komisi-unilevel',
					name: 'detail-komisi-unilevel',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/komisi/detailUnilevel/DetailUnilevel.vue')
				},
				{
					path: '/buat-pesan/:code?',
					name: 'buat-pesan',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/buatPesan/BuatPesan.vue')
				},
				{
					path: '/pesan-masuk',
					name: 'pesan-masuk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/pesanMasuk/PesanMasuk.vue')
				},
				{
					path: '/pesan-terkirim',
					name: 'pesan-terkirim',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/pesanTerkirim/PesanTerkirim.vue')
				},
				{
					path: '/detail-pesan-masuk/:id?',
					name: 'detail-pesan-masuk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pesan/pesanMasuk/components/DetailPesan.vue')
				},
				{
					path: '/detail-pesan-terkirim/:id?',
					name: 'detail-pesan-terkirim',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/pesan/pesanTerkirim/components/DetailPesan.vue')
				},
				{
					path: '/pengajuan-stokis/',
					name: 'pengajuan-stokis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/pengajuanStokis/PengajuanStokis.vue')
				},
				{
					path: '/summary-saldo/',
					name: 'summary-saldo',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/saldoAnda/summarySaldo/SummarySaldo.vue')
				},
				{
					path: '/pajak',
					name: 'pajak',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/perpajakan/LapPajak.vue')
				},
				{
					path: '/daftar-stokis',
					name: 'daftar-stokis',
					beforeEnter: isAuth,
					component: () => import ('@/views/vo-general/listStokist/index.vue')
				},

				// stokis area path
				{
					path: '/belanja-produk',
					name: 'belanja-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/belanjaProduk/BelanjaProduk.vue')
				},
				{
					path: '/lap-belanja-produk',
					name: 'lap-belanja-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/lapBelanjaProduk/LapBelanjaProduk.vue')
				},
				{
					path: '/detail-belanja-produk/:code?',
					name: 'detail-belanja-produk',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/lapBelanjaProduk/DetailBelanjaProduk.vue')
				},
				{
					path: '/lap-penjualan',
					name: 'lap-penjualan',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/lapPenjualan/LapPenjualan.vue')
				},
				{
					path: '/detail-penjualan/:code?',
					name: 'detail-penjualan',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/lapPenjualan/DetailPenjualan.vue')
				},
				{
					path: '/stok-serial-stokis',
					name: 'stok-serial-stokis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/stokSerial/StokSerial.vue')
				},
				{
					path: '/kirim-serial-stokis',
					name: 'kirim-serial-stokis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/kirimSerial/KirimSerial.vue')
				},
				{
					path: '/riwayat-serial-stokis',
					name: 'riwayat-serial-stokis',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/stokisArea/riwayatSerialStokis/RiwayatSerialStokis.vue')
				},
				{
					path: '/web-replika',
					name: 'web-replika',
					beforeEnter: isAuth,
					component: () => import('@/views/vo-general/webReplika/index.vue')
				},
			]
		},
		{
			path: '*',
			component: () => import('@/components/layout/vo-general/ErrorPage.vue'),
			children: [
				{
					path: '/maintenance',
					component: () => import('@/views/Maintenance.vue')
				},
				{
					path: '*',
					name: 'not-found',
					component: () => import('@/views/404.vue')
				}
			]
		}
	],
	scrollBehavior (to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	}
});